import CM                            from '@emersya/mpa-components-manager-lib';
import * as STD                      from '@emersya/mpa-std-lib';
import ViewerComponent               from '../../../viewer/Viewer/Viewer';
import { PlannerWallsTileComponent } from '../../../viewer/planner/walls/ProductTile/PlannerWallsProductTile';

export interface IStandingObjectsPositioningDynamicsSetsComponentConfiguration extends CM.Component.IConfiguration {
};

export class StandingObjectsPositioningDynamicsSetsComponent extends CM.Component<
	StandingObjectsPositioningDynamicsSetsComponent,
	IStandingObjectsPositioningDynamicsSetsComponentConfiguration
>
{
	readonly products : {
		readonly tv : ViewerComponent.Product[]
	} = {
		tv : []
	};

	onProductTypeAdded(...x : any[]) {
		void x;
	};

	async refreshTvPositions() {
		const walls = <PlannerWallsTileComponent[]> app.component_find(
			'K.modules:panel.viewer-planner-walls-editor.content:menu').component_outerChilds;
		if (!app.viewer.planner) {
			this.component_throwLibraryError('');
		}
		const roomSize = app.viewer.planner.size;
		const d2 = roomSize.depth / 2;
		const w2 = roomSize.width / 2;
		let i = 0;
		// const SKUTV = ['17PB01A','17PB01B','17PB01E','17PB01D'];
		// const TVs = app.component_configuration.productsComponents.filter(x => SKUTV.includes(x.SKU));
		// const tvRails = walls.filter(x => !x.component_isDisabled).
		// reduce<Record<string, { position : [ number, number, number ], rotationaxis : [number, number, number], rotationAngle : number }>>((a, wall) => {
		// 	const zone = wall.getWallImageCustomizationZone();
		// 	for (let o = 0; o < zone.size.x; o += .2) {
		// 		let x : number;
		// 		let z : number;
		// 		if (wall.id === 'back') {
		// 			x = (o + zone.offset.left) - w2;
		// 			z = -d2;
		// 		} else {
		// 			z = (o + zone.offset.left) - d2;
		// 			if (wall.id === 'left') {
		// 				x = -w2;
		// 			} else {
		// 				x = w2;
		// 			}
		// 		}
		// 		if(wall.id === 'left'){
		// 			a[ i++ ] = {
		// 				position : [ x, 1.6, z ],
		// 				rotationaxis : [0, 0, 0],
		// 				rotationAngle : 90
		// 			};
		// 		}else if(wall.id === 'right'){
		// 			a[ i++ ] = {
		// 				position : [ x, 1.6, z ],
		// 				rotationaxis : [0, 0, 0],
		// 				rotationAngle : 270
		// 			};
		// 		}else{
		// 			a[ i++ ] = {
		// 				position : [ x, 1.6, z ],
		// 				rotationaxis : [0, 0, 0],
		// 				rotationAngle : 0
		// 			};
		// 		}
		// 	}
		// 	return a;
		// }, {});

		type TP  = Parameters<ViewerComponent['setPlannerFixedPositions']>[0][''];
		const product = app.currentProduct;
		if(!product){
			this.component_throwUserError('');
		}
		const layoutPart = product.getPart(['layout']);
		if(!layoutPart){
			this.component_throwUserError('');
		}
		const layoutOption = layoutPart.currentOption;
		if(!layoutOption){
			this.component_throwUserError('');
		}
		const layoutOptionId = layoutOption.id;
		if(layoutOptionId === 'shape-no-wall'){
			for (const xx of
				Array.from(app.viewer.safe.value.productInstances).
				filter(x => x.product.name.startsWith('TV') && x.metadata.isUserInserted))
			{
				await xx.delete();
			}
			await app.viewer.setPlannerFixedPositions(this.products.tv.reduce<Record<string, TP>>((a0, p) => {
				a0[`tv-${p.SKU}`] = {
					positions : {

					}
				};
				return a0;
			}, {}));
			return;
		}
		await app.viewer.setPlannerFixedPositions(this.products.tv.reduce<Record<string, TP>>((a0, p) => {
			const pc = app.component_configuration.productsComponents.find(x => x.SKU === p.SKU);
			if(!pc){
				this.component_throwUserError('Missing product components in app conf with SKU : '+p.SKU);
			}
			const boundingBox = pc.boundingBox;
			if(!boundingBox){
				this.component_throwUserError('Missing bounding box for component : '+pc.SKU)
			}
			a0[`tv-${p.SKU}`] = {
				positions : walls.filter(x => !x.component_isDisabled).
				reduce<Record<string, { position : [ number, number, number ], rotationaxis : [number, number, number], rotationAngle : number }>>((a1, wall) => {
					const zone = wall.getWallImageCustomizationZone();
					if(zone.isCut){
						for (let o = .1; o < zone.size.x-boundingBox.width; o += .2) {
							let x : number;
							let z : number;
							if (wall.id === 'back') {
								x = (o + zone.offset.left) - w2;
								z = -d2;
								if(x > zone.cut.start - w2 - boundingBox.width && x < zone.cut.end - w2){
									continue;
								}
							} else if(wall.id === 'right') {
								z = (o + zone.offset.left) - d2;
								x = w2;
								if(z > zone.cut.start-d2 - boundingBox.width && z < zone.cut.end - d2){
									continue;
								}
							}else{
								z = d2 - (o + zone.offset.left);
								x = -w2;
								if(z < d2 + boundingBox.width - zone.cut.start && z > d2 - zone.cut.end){
									continue;
								}
							}
							if(wall.id === 'left'){
								a1[ i++ ] = {
									position : [ x, 1.6, z ],
									rotationaxis : [0, 0, 0],
									rotationAngle : 90
								};
							}else if(wall.id === 'right'){
								a1[ i++ ] = {
									position : [ x, 1.6, z ],
									rotationaxis : [0, 0, 0],
									rotationAngle : 270
								};
							}else{
								a1[ i++ ] = {
									position : [ x, 1.6, z ],
									rotationaxis : [0, 0, 0],
									rotationAngle : 0
								};
							}
						}
						return a1;
					}else{
						for (let o = .1; o < zone.size.x-boundingBox.width; o += .2) {
							let x : number;
							let z : number;
							if (wall.id === 'back') {
								x = (o + zone.offset.left) - w2;
								z = -d2;
							} else if(wall.id === 'right') {
								z = (o + zone.offset.left) - d2;
								x = w2;
							}else{
								z = d2 - (o + zone.offset.left);
								x = -w2;
							}
							if(wall.id === 'left'){
								a1[ i++ ] = {
									position : [ x, 1.6, z ],
									rotationaxis : [0, 0, 0],
									rotationAngle : 90
								};
							}else if(wall.id === 'right'){
								a1[ i++ ] = {
									position : [ x, 1.6, z ],
									rotationaxis : [0, 0, 0],
									rotationAngle : 270
								};
							}else{
								a1[ i++ ] = {
									position : [ x, 1.6, z ],
									rotationaxis : [0, 0, 0],
									rotationAngle : 0
								};
							}
						}
						return a1;
					}
				}, {})
			};
			// a0[`tv.${p.SKU}`] = walls.filter(x => !x.component_isDisabled).
			// reduce<Record<string, { position : [ number, number, number ], rotationaxis : [number, number, number], rotationAngle : number }>>((a1, wall) => {
			// 	const zone = wall.getWallImageCustomizationZone();
			// 	for (let o = 0; o < zone.size.x; o += .2) {
			// 		let x : number;
			// 		let z : number;
			// 		if (wall.id === 'back') {
			// 			x = (o + zone.offset.left) - w2;
			// 			z = -d2;
			// 		} else {
			// 			z = (o + zone.offset.left) - d2;
			// 			if (wall.id === 'left') {
			// 				x = -w2;
			// 			} else {
			// 				x = w2;
			// 			}
			// 		}
			// 		if(wall.id === 'left'){
			// 			a[ i++ ] = {
			// 				position : [ x, 1.6, z ],
			// 				rotationaxis : [0, 0, 0],
			// 				rotationAngle : 90
			// 			};
			// 		}else if(wall.id === 'right'){
			// 			a[ i++ ] = {
			// 				position : [ x, 1.6, z ],
			// 				rotationaxis : [0, 0, 0],
			// 				rotationAngle : 270
			// 			};
			// 		}else{
			// 			a[ i++ ] = {
			// 				position : [ x, 1.6, z ],
			// 				rotationaxis : [0, 0, 0],
			// 				rotationAngle : 0
			// 			};
			// 		}
			// 	}
			// 	return a;
			// }, {});
			return a0;
		}, {}));
	};

	override async component_start(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(ev);
		const productsWithCustomPositions = {
			'tv' : [
				'17PB01A', // real SKU
				'17PB01B', // real SKU
				'17PB01E', // real SKU
				'17PB01D'  // real SKU
				// 'furniture-table' // debug
			]
		};
		const allProducts = app.viewer.categories.map(x => x.products).flat();
		this.products.tv.push(...allProducts.filter(x => productsWithCustomPositions.tv.includes(x.SKU)));
		for (const tv of this.products.tv) {
			tv.positionsSetId = `tv-${tv.getId()}`;
		}
	};

	constructor(
		descriptor : CM.Component.IDescriptor,
		configuration : IStandingObjectsPositioningDynamicsSetsComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = StandingObjectsPositioningDynamicsSetsComponent;
	export type Component = StandingObjectsPositioningDynamicsSetsComponent;
	export type Configuration = IStandingObjectsPositioningDynamicsSetsComponentConfiguration;
}
import manifestXMLSource             from './StandingObjectsPositioningDynamicsSets.xml';

CM.declare({
	id :       'standing-objectsPositioningDynamicsSets',
	type :     StandingObjectsPositioningDynamicsSetsComponent,
	manifest : manifestXMLSource
});
